package app.bloomey.web.core.di

import app.bloomey.web.core.data.ApiClient
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import io.ktor.client.*
import org.koin.core.context.startKoin
import org.koin.dsl.module


@InitSilk
fun initDi(context: InitSilkContext) {
    startKoin {
        modules(
            mainModules
        )
    }
}

val mainModules = module {
    single<HttpClient> {
        ApiClient.client
    }
}